import { render, staticRenderFns } from "./qrCustomize.vue?vue&type=template&id=11138a85&scoped=true"
import script from "./qrCustomize.vue?vue&type=script&lang=js"
export * from "./qrCustomize.vue?vue&type=script&lang=js"
import style0 from "./qrCustomize.vue?vue&type=style&index=0&id=11138a85&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11138a85",
  null
  
)

export default component.exports